import { mainSiteUrl } from '@/mocks/categories';

export default function CtaBanner() {
  return (
    <section className="relative w-full py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20inviting%20lifestyle%20scene%20with%20a%20laptop%20showing%20shopping%20interface%20surrounded%20by%20fashion%20magazines%20coffee%20cup%20and%20potted%20plant%20on%20a%20wooden%20desk%20near%20a%20sunlit%20window%2C%20modern%20boutique%20workspace%20aesthetic%20with%20soft%20beige%20cream%20and%20sage%20green%20tones%2C%20editorial%20photography%20with%20gentle%20natural%20lighting%20and%20organic%20composition&width=1600&height=600&seq=cta-banner-v2-2026&orientation=landscape"
          alt="Visit Basetao Spreadsheet main shopping platform"
          title="Explore Basetao Spreadsheet Resources"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/35 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-6 md:px-8 text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-white mb-4">
          Ready to Start Your Basetao Spreadsheet Journey?
        </h2>
        <p className="text-white/80 text-sm md:text-base mb-8 max-w-lg mx-auto leading-relaxed">
          Explore the latest Basetao Spreadsheet collections, discover trending products, and make smarter shopping decisions today.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-label font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 hover:scale-105 cursor-pointer"
          >
            <i className="ri-shopping-bag-3-line text-lg"></i>
            basetao spreadsheet
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm text-white border border-white/30 font-label font-semibold text-sm md:text-base hover:bg-white/25 transition-all duration-300 hover:scale-105 cursor-pointer"
          >
            <i className="ri-flashlight-line text-lg"></i>
            buy it now
          </a>
        </div>
      </div>
    </section>
  );
}